/**
 * Lightweight confetti utility
 * Uses canvas-confetti for celebration animations
 */

/**
 * Check if user prefers reduced motion
 */
function prefersReducedMotion(): boolean {
  return window.matchMedia('(prefers-reduced-motion: reduce)').matches;
}

/**
 * Trigger confetti celebration
 * @param options - Confetti configuration
 */
export async function triggerConfetti(options?: {
  particleCount?: number;
  spread?: number;
  origin?: { x: number; y: number };
}) {
  // Skip if reduced motion is preferred
  if (prefersReducedMotion()) {
    return;
  }

  // Dynamically import canvas-confetti only when needed
  const confetti = await import('canvas-confetti').then((m) => m.default);

  const defaults = {
    particleCount: 100,
    spread: 70,
    origin: { y: 0.6 },
  };

  void confetti({
    ...defaults,
    ...options,
  });
}

/**
 * Trigger a burst of confetti from the center
 */
export async function celebrateTaskCompletion() {
  if (prefersReducedMotion()) {
    return;
  }

  const confetti = await import('canvas-confetti').then((m) => m.default);

  // Fire confetti from center with nice spread
  const count = 200;
  const defaults = {
    origin: { y: 0.7 },
    zIndex: 9999,
  };

  function fire(particleRatio: number, opts: Record<string, unknown>) {
    void confetti({
      ...defaults,
      ...opts,
      particleCount: Math.floor(count * particleRatio),
    });
  }

  // Multiple bursts for better effect
  fire(0.25, {
    spread: 26,
    startVelocity: 55,
  });

  fire(0.2, {
    spread: 60,
  });

  fire(0.35, {
    spread: 100,
    decay: 0.91,
    scalar: 0.8,
  });

  fire(0.1, {
    spread: 120,
    startVelocity: 25,
    decay: 0.92,
    scalar: 1.2,
  });

  fire(0.1, {
    spread: 120,
    startVelocity: 45,
  });
}
